<template>
    <div v-if="location != null" class="location-search-container__results--list-item">
        <h1 class="sr-only">Locations</h1>
        <div class="row back-cta-block">
            <div class="col-12">
                <a href="javascript:;" v-if="!isSpecificLocation" v-on:click.stop="unSelectLocationClick">Back to find a Location</a>
            </div>
        </div>
        
        <div class="row address-block">
            <div class="col-12">
                <h2 class="h4 name detail-name">{{ location.name }}</h2>
                <span v-html="address"></span><br />
                <div v-if="location.phone">P: <a class="tel" v-bind:href="telephone">{{ location.phone }}</a></div>
                <div v-if="location.fax">F: {{ location.fax }}</div>
            </div>
        </div>
        <div class="row directions-block">
            <div class="col-12">
                <a v-bind:href="directions" target="_blank"><img src="/assets/images/directions_icon.svg"
                        alt="" />{{ text("directions") }}</a>
            </div>
        </div>
        <div v-if="location.notice" class="row notice-block">
            <div class="col-12" v-html="noticeText">
            </div>
        </div>
       
        <results-item-hours
              :heading="location.isAtm ? text('availability') : text('lobby')"
              :location="location"
              :hours="location.lobbyHours"
              :detailView="true"
              :idcontrol="location.id"
              :holidays="location.holidayHours"
        ></results-item-hours>

        <results-item-hours     
            :heading="text('driveThru')"
            :location="location"
            :hours="location.driveThruHours"
            :detailView="true"
            :idcontrol="location.id"
            :holidays="location.holidayHours"
        ></results-item-hours>

        <div class="row hours-block" v-if="location.driveUpAtm">
            <div class="col-12">
                <h3 class="heading">{{ text("driveUpAtm") }}</h3>
                <div class="now nodetails" v-html="location.driveThruAtmHours"></div>
            </div>
        </div>

        <div class="row hours-block" v-if="location.walkUpAtm">
            <div class="col-12">
                <h3 class="heading">{{ text("walkUpAtm") }}</h3>
                <div class="now nodetails" v-html="location.walkUpAtmHours"></div>
            </div>
        </div>

        <div class="row services-block" v-if="services">
            <div class="col-12">
                <span class="heading">{{ text("services") }}</span>
                {{ servicesString }}
            </div>
        </div>
    </div>
</template>

<script>
import { locText } from "../../../utils/useText";
import * as resultsFunctions from "../functions/results";
import Hours from "./ResultsItemHours.vue";

export default {
    data() {
        return {
        }
    },
    mounted() {
        if (typeof HERO_speedbump != "undefined") {
            setTimeout(function(){ 
                HERO_speedbump.init();
            }, 1000);
        }
    },
    components: {
        "results-item-hours": Hours
    },
    computed: {
        address() {
            return resultsFunctions.formatAddress(this.location);
        },        
        directions() {
            let loc = this.userSearch;
            if (!loc.lat && !loc.lng)
                loc = this.userLocation;

            return resultsFunctions.formatDirectionsLink(this.location, loc);
        },
        isSpecificLocation() {
            return this.$store.state.isSpecificLocation;    
        },
        noticeText() {
            if (this.location.notice) {
                let prefix = "<img class=\"icon\" src=\"/assets/images/notice_icon.png\" /><strong>Notice</strong>: ";
                return this.location.notice.replace("\<p\>", "<p>" + prefix);
            }
        },
        services() {
            return resultsFunctions.hasServices(this.location);
        },
        servicesString() {
            return resultsFunctions.formatServicesString(this.location);
        },
        telephone() {
            return resultsFunctions.formatTelephone(this.location);
        },
        userLocation() {
            return this.$store.state.userLocation;
        },
        userSearch() {
            return this.$store.state.userSearch;
        }
    },
    mixins: [locText],
    props: {
        location: Object,
        unSelectLocationClick: Function
    }
}
</script>
